import { ActionIcon, CopyButton, Group, Text, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";

import ObservationMetadataRow from "./ObservationMetadataRow";

interface CopyableFieldProps {
  label: string;
  value: string;
}

export default function CopyableField({ label, value }: CopyableFieldProps) {
  return (
    <ObservationMetadataRow label={label}>
      <Group gap={6} wrap="nowrap" align="center">
        <Text size="sm" style={{ minWidth: 0, overflowWrap: "anywhere" }}>
          {value}
        </Text>
        <CopyButton value={value}>
          {({ copied, copy }) => (
            <Tooltip label={copied ? "Copied" : "Copy"}>
              <ActionIcon
                size="xs"
                variant="subtle"
                color={copied ? "green" : "gray"}
                onClick={copy}
                style={{ flexShrink: 0 }}
              >
                {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
              </ActionIcon>
            </Tooltip>
          )}
        </CopyButton>
      </Group>
    </ObservationMetadataRow>
  );
}
